/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyOfficerPeriodicReportResponse } from '../models/get-safety-officer-periodic-report-response';
import { GetFormRequest } from '../models/get-form-request';
import { CreateSafetyOfficerPeriodicReportRequest } from '../models/create-safety-officer-periodic-report-request';
@Injectable({
  providedIn: 'root',
})
class SafetyOfficerPeriodicReportService extends __BaseService {
  static readonly SafetyOfficerPeriodicReportGetAllPath = '/SafetyOfficerPeriodicReport/GetAll';
  static readonly SafetyOfficerPeriodicReportGetByIdPath = '/SafetyOfficerPeriodicReport/GetById';
  static readonly SafetyOfficerPeriodicReportCreatePath = '/SafetyOfficerPeriodicReport/Create';
  static readonly SafetyOfficerPeriodicReportUploadFilePath = '/SafetyOfficerPeriodicReport/UploadFile';
  static readonly SafetyOfficerPeriodicReportDeletePath = '/SafetyOfficerPeriodicReport/Delete';
  static readonly SafetyOfficerPeriodicReportDeleteRangePath = '/SafetyOfficerPeriodicReport/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyOfficerPeriodicReportGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyOfficerPeriodicReportResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyOfficerPeriodicReport/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyOfficerPeriodicReportResponse>>;
      })
    );
  }  SafetyOfficerPeriodicReportGetAll(): __Observable<Array<GetSafetyOfficerPeriodicReportResponse>> {
    return this.SafetyOfficerPeriodicReportGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyOfficerPeriodicReportResponse>)
    );
  }

  /**
   * @param request undefined
   */
  SafetyOfficerPeriodicReportGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetSafetyOfficerPeriodicReportResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyOfficerPeriodicReport/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyOfficerPeriodicReportResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyOfficerPeriodicReportGetById(request: GetFormRequest): __Observable<GetSafetyOfficerPeriodicReportResponse> {
    return this.SafetyOfficerPeriodicReportGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetSafetyOfficerPeriodicReportResponse)
    );
  }

  /**
   * @param request undefined
   */
  SafetyOfficerPeriodicReportCreateResponse(request: CreateSafetyOfficerPeriodicReportRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyOfficerPeriodicReport/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyOfficerPeriodicReportCreate(request: CreateSafetyOfficerPeriodicReportRequest): __Observable<string> {
    return this.SafetyOfficerPeriodicReportCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `SafetyOfficerPeriodicReportService.SafetyOfficerPeriodicReportUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyOfficerPeriodicReportUploadFileResponse(params: SafetyOfficerPeriodicReportService.SafetyOfficerPeriodicReportUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.FormId != null) { __formData.append('FormId', params.FormId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyOfficerPeriodicReport/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SafetyOfficerPeriodicReportService.SafetyOfficerPeriodicReportUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyOfficerPeriodicReportUploadFile(params: SafetyOfficerPeriodicReportService.SafetyOfficerPeriodicReportUploadFileParams): __Observable<Blob> {
    return this.SafetyOfficerPeriodicReportUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyOfficerPeriodicReportDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyOfficerPeriodicReport/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyOfficerPeriodicReportDelete(id?: string): __Observable<Blob> {
    return this.SafetyOfficerPeriodicReportDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyOfficerPeriodicReportDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyOfficerPeriodicReport/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyOfficerPeriodicReportDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyOfficerPeriodicReportDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyOfficerPeriodicReportService {

  /**
   * Parameters for SafetyOfficerPeriodicReportUploadFile
   */
  export interface SafetyOfficerPeriodicReportUploadFileParams {
    FormId?: string;
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { SafetyOfficerPeriodicReportService }
